import React from 'react'
import { ReactComponent as Eye } from '../../assets/icons/table/eye.svg'
import { ReactComponent as Edit } from '../../assets/icons/table/edit.svg'
import { ReactComponent as Bag } from '../../assets/icons/table/bag-cross.svg'
import { ReactComponent as Copy } from '../../assets/icons/table/copy-success.svg'
import { ReactComponent as Print } from '../../assets/icons/table/printer.svg'
import { Box, IconButton, styled, SxProps } from '@mui/material'
import FileDownloadOutlinedIcon from '@mui/icons-material/FileDownloadOutlined';
import WarehouseIcon from '@mui/icons-material/Warehouse';

import SaveAsIcon from '@mui/icons-material/SaveAs';
import UndoIcon from '@mui/icons-material/Undo';
import { colors } from '../../constants/colors'

type Props = {
    enableView?: boolean;
    enableEdit?: boolean;
    enableDelete?: boolean;
    enableCopy?: boolean;
    enableCancel?: boolean;
    enableDownload?: boolean;
    enableSave?: boolean;
    enableStock?: boolean;
    enablePrint?: boolean;
    onCopy?: () => void;
    onViewClick?: (e?: any) => void;
    onEditClick?: (e?: any) => void;
    onDeleteClick?: (e?: any) => void;
    onCancelClick?: () => void;
    onStockClick?: () => void;
    onSaveClick?: () => void;
    onDownloadClick?: () => void;
    onPrintClick?: () => void;
    disabledDownload?: boolean;
    disabledView?: boolean;
    disabledEdit?: boolean;
    disabledDelete?: boolean;
    disabledCopy?: boolean;
    disabledCancel?: boolean;
    disabledSave?: boolean;
    disabledStock?: boolean;
    disabledPrint?: boolean;
    sx?: SxProps;
}
const IconButtonCustomStyle = styled(IconButton)({
    '&:disabled': {
        opacity: .4
    }
})

const OptionsButtonCustom: React.FC<Props> = ({
    enableDelete,
    enableEdit,
    enableView,
    onEditClick,
    onDeleteClick,
    onViewClick,
    enableCopy,
    onCopy,
    onCancelClick,
    onSaveClick,
    disabledCancel,
    disabledSave,
    enableCancel,
    enableSave,
    disabledCopy,
    disabledDelete,
    disabledEdit,
    disabledView,
    enableDownload,
    disabledDownload,
    onDownloadClick,
    enableStock,
    disabledStock,
    onStockClick,
    enablePrint,
    onPrintClick,
    disabledPrint,
    sx
}: Props) => {
    return (
        <Box className={"flex flex-start items-center transition-all "}>
            {enableStock && (
                <IconButtonCustomStyle sx={sx} disabled={disabledStock} onClick={onStockClick}>
                    <WarehouseIcon />
                </IconButtonCustomStyle>
            )}
            {enableView && (
                <IconButtonCustomStyle sx={sx} disabled={disabledView} onClick={onViewClick}>
                    <Eye />
                </IconButtonCustomStyle>
            )}
            {enableCopy && (
                <IconButtonCustomStyle sx={sx} disabled={disabledCopy} onClick={onCopy}>
                    <Copy />
                </IconButtonCustomStyle>
            )}
            {enableEdit && (
                <IconButtonCustomStyle sx={sx} disabled={disabledEdit} onClick={onEditClick}>
                    <Edit />
                </IconButtonCustomStyle>
            )}
            {enableDownload && (
                <IconButtonCustomStyle sx={sx} disabled={disabledDownload} onClick={onDownloadClick}>
                    <FileDownloadOutlinedIcon />
                </IconButtonCustomStyle>
            )}
            {enableDelete && (
                <IconButtonCustomStyle sx={sx} disabled={disabledDelete} onClick={onDeleteClick}>
                    <Bag />
                </IconButtonCustomStyle>
            )}
            {enableCancel && (
                <IconButtonCustomStyle sx={{ ...sx, color: colors.black_60 }} disabled={disabledCancel} onClick={onCancelClick}>
                    <UndoIcon />
                </IconButtonCustomStyle>
            )}
            {enableSave && (
                <IconButtonCustomStyle sx={{ ...sx, color: colors.themeMainColor }} disabled={disabledSave} onClick={onSaveClick}>
                    <SaveAsIcon />
                </IconButtonCustomStyle>
            )}
            {enablePrint && (
                <IconButtonCustomStyle sx={{ ...sx, color: colors.themeMainColor }} disabled={disabledPrint} onClick={onPrintClick}>
                    <Print />
                </IconButtonCustomStyle>
            )}
        </Box>
    )
}

export default OptionsButtonCustom